import React from 'react';
import styles from './advanced-checklists-beta-info.less';
import { forTemplate } from 'app/common/lib/util/i18n';

const format = forTemplate('advanced_checklists');

interface AdvancedChecklistsBetaInfoProps {}

export const AdvancedChecklistsBetaInfo: React.FunctionComponent<AdvancedChecklistsBetaInfoProps> = () => (
  <div className={styles.advancedChecklistsBetaInfo}>
    {format('advanced-checklists-beta-info')}{' '}
    <a
      className={styles.feedback}
      href="https://trello.typeform.com/to/zNxCoT"
      target="survey"
    >
      {format('feedback')}
    </a>
  </div>
);
